import VeeValidate from 'vee-validate'
import Notifications from 'vue-notification'
import CustomNotifications from 'mixins/custom_notifications'
import string from "../components/common/string_utilities";
import Vue from 'vue/dist/vue.esm.js';
import VueRouter from "vue-router"
import Vuex from 'vuex'
import VueSkeletonLoader from 'skeleton-loader-vue';
import Popover from 'vue-js-popover'
import StoreSwitcher from '../components/shared/store_switcher.vue'

window.Vue = Vue
window.VueRouter = VueRouter
window.Vuex = Vuex
window.VueSkeletonLoader = VueSkeletonLoader

Vue.use(VueSkeletonLoader);
Vue.use(Vuex)
Vue.use(VueRouter);
Vue.use(string)
Vue.use(Notifications);
Vue.use(VeeValidate);
Vue.mixin(CustomNotifications);
Vue.use(Popover, { tooltip: true })

// Initialize store switcher component if the element exists
document.addEventListener('DOMContentLoaded', () => {
  const storeSwitcherEl = document.getElementById('store-switcher');
  if (storeSwitcherEl) {
    new Vue({
      el: '#store-switcher',
      render: h => h(StoreSwitcher)
    });
  }
});
